class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }
  
    onVariantChange() {
      this._hidePickupAvailabilityWhileUpdating();
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.updateOnlinesizing();
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
      }
    }
  
    updateOnlinesizing() {
      const sizingButtonOne = document.getElementById('oz-trigger-1');
      const sizingButtonTwo = document.getElementById('oz-trigger-2');

      if (!sizingButtonOne || !sizingButtonTwo) {
        return; 
      }

      // Warte auf Smartfit-Script (window.oz)
      if (!window.oz || !window.oz.widgets) {
        console.log('[Smartfit] Waiting for oz widget to load...');
        
        // Retry nach 500ms
        setTimeout(() => {
          this.updateOnlinesizing();
        }, 500);
        return;
      }

      if (this.currentVariant) {
        const barcode = this.currentVariant.barcode;
        const featuredImage = this.currentVariant.featured_image;

        if (barcode && featuredImage) {
          sizingButtonOne.setAttribute(`data-${window.oz.namespace}-code`, barcode);
          sizingButtonTwo.setAttribute(`data-${window.oz.namespace}-code`, barcode);

          sizingButtonOne.setAttribute(`data-${window.oz.namespace}-image`, featuredImage.src);
          sizingButtonTwo.setAttribute(`data-${window.oz.namespace}-image`, featuredImage.src);

          window.oz.updateWidgetConfigurations([sizingButtonOne]);
          window.oz.updateWidgetConfigurations([sizingButtonTwo]);
          
          console.log('[Smartfit] Widget updated successfully');
        } else {
          console.error('[Smartfit] Barcode or featured image is missing from the current variant.');
        }
      } else {
        console.error('[Smartfit] Current variant is not defined.');
      }
    }
  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        if (variant.options.includes('Default Title')) return variant.id;
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
  
    updateMedia() {
      if (!this.currentVariant || !this.currentVariant?.featured_media) return;
      const newMedia = document.querySelector(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
      );
      if (!newMedia) return;
      const parent = newMedia.parentElement;
      parent.prepend(newMedia);
      window.setTimeout(() => { parent.scroll(0, 0) });
    }
  
    updateURL() {
      // if (!this.currentVariant) return;
      // const urlParams = new URLSearchParams(window.location.search);
      // urlParams.set('variant', this.currentVariant.id);
      // window.history.replaceState({ }, '', `${this.dataset.url}?${urlParams}`);
  
      if (!this.currentVariant) return;
      const urlParameters = location.search.split('&').filter(param => !param.includes('variant=')).join('&');
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}${urlParameters ? '&' + urlParameters : ''}`);
    }
  
    updateVariantInput() {
      let slidesTotal = variantImages[this.currentVariant.id].length;
      let slidesValue = document.querySelector('.number-pag-swiper-main');
      slidesValue.textContent = `1/${slidesTotal}`;
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    _hidePickupAvailabilityWhileUpdating() {
      const el = document.querySelector('pickup-availability');
      if (!el) return;
      el.classList.add('pickup-availability--updating');
      if (this._pickupShowTimeout) clearTimeout(this._pickupShowTimeout);
      this._pickupShowTimeout = setTimeout(() => {
        el.classList.remove('pickup-availability--updating');
        this._pickupShowTimeout = null;
      }, 1400);
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;

      try {
          if (this.currentVariant?.available) {
              if (pickUpAvailability && typeof pickUpAvailability.fetchAvailability === 'function') {
                  pickUpAvailability.fetchAvailability(this.currentVariant.id);
              }
          } else {
              pickUpAvailability.removeAttribute('available');
              pickUpAvailability.innerHTML = '';
          }
        } catch (error) {
          // Error handling
      }
    }
  
    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const id = `price-${this.dataset.section}`;
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(id);
          const source = html.getElementById(id);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
  
          document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
  
          const pathname = window.location.pathname;
          const index = pathname.lastIndexOf('/') + 1;
          const productHandle = pathname.substring(index);
          
          window.inventoryInfo.api.loadApp({
            handle: productHandle,
            variant: this.currentVariant.id
          });
        });
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&sections=delivery`)
          .then((response) => response.json())
          .then((responseJson) => {
            const id = 'shopify-section-delivery';
            const html = new DOMParser().parseFromString(responseJson['delivery'], 'text/html');
            const source = html.getElementById(id);
            const destination = document.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
          });
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
  
      if (!addButton) return;
  
      if (disable) {
        addButton.setAttribute('disabled', true);
        if (text) addButton.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButton.textContent = window.variantStrings.addToCart;
      }
  
      if (!modifyClass) return;
    }
  
    setUnavailable() {
      const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
      if (!addButton) return;
      addButton.textContent = window.variantStrings.unavailable;
      document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
    }
  
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  
  customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }
  
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }
  
  customElements.define('variant-radios', VariantRadios);

class VariantColourSwatch extends VariantRadios {
    constructor() {
      super();
      
      try {
        this.onVariantChange();
      } catch (error) {
        setTimeout(() => this.onVariantChange(), 1000);
      }
    }
  
    onVariantChange() {
      super.onVariantChange();
      if (!this.currentVariant) return;
      document.querySelector(".product__title .sku").innerHTML =
        this.currentVariant.sku;
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&sections=size-select`)
        .then((response) => response.json())
        .then((responseJson) => {
          const id = 'shopify-section-size-select';
          const html = new DOMParser().parseFromString(responseJson['size-select'], 'text/html');
          const source = html.getElementById(id).innerHTML;
          const destination = document.querySelector('[name="options[Rahmenhoehe]"]');
          if (source && destination) destination.innerHTML = source;
        });
      
      // Also update gallery from metafield (will wait for rerender)
      this.updateMediaFromMetafield();
    }
    
    updateMediaFromMetafield() {
      if (!this.currentVariant) return;
      
      // Wait for theme's rerender to complete before updating gallery
      // This prevents interference with the theme's DOM manipulation
      // Listen for the rerender completion on document level
      const handleRerender = () => {
        // Use setTimeout to ensure rerender is fully complete
        setTimeout(() => {
          this.updateMediaFromMetafieldInternal();
        }, 100);
      };
      
      // Remove previous listener to avoid duplicates
      document.removeEventListener('product:rerender', handleRerender);
      document.addEventListener('product:rerender', handleRerender, { once: true });
      
      // Also try immediately in case rerender already happened
      setTimeout(() => {
        this.updateMediaFromMetafieldInternal();
      }, 200);
    }
    
    updateMediaFromMetafieldInternal() {
      if (!this.currentVariant) {
        return;
      }
      
      // Get variant metafield images
      const variantMediasScript = document.querySelector('[data-variant-medias]');
      if (!variantMediasScript) {
        return;
      }
      
      let variantMediasMap = {};
      
      if (variantMediasScript && variantMediasScript.textContent) {
        try {
          const scriptContent = variantMediasScript.textContent.trim();
          if (scriptContent) {
            variantMediasMap = JSON.parse(scriptContent);
          }
        } catch (e) {
          variantMediasMap = {};
        }
      }
      
      // Try both string and number keys (variant IDs might be stored as strings in JSON)
      const variantId = this.currentVariant.id;
      const variantIdString = String(variantId);
      const variantIdNumber = Number(variantId);
      
      let variantMedias = variantMediasMap[variantId] || 
                          variantMediasMap[variantIdString] || 
                          variantMediasMap[variantIdNumber] || 
                          [];
      
      if (Array.isArray(variantMedias) && variantMedias.length > 0) {
        this.updateProductGallery(variantMedias);
      }
    }
  
    updateOptions() {
      const colourSwatches = Array.from(this.querySelectorAll("fieldset"));
      this.options = colourSwatches.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      });
      if (this.options[0]) {
        this.querySelector(".colour-option-name").innerHTML =
          this.options[0].toLowerCase();
          this.querySelectorAll("input").forEach((el) =>
            el.removeAttribute("checked")
          );
          const checkedInput = this.querySelector(
            `input[value="${this.options[0]}"]`
          );
          checkedInput.setAttribute("checked", "");
          const slide = checkedInput.closest(".swiper-slide");
      }
      const sizeSelect = document.querySelector("variant-size-selects");
      if (sizeSelect?.options?.length) {
        this.options.push(sizeSelect.options[1]);
      }
    }
  
    updateMedia() {
      // Get variant metafield images
      const variantMediasScript = document.querySelector('[data-variant-medias]');
      let variantMediasMap = {};
      
      if (variantMediasScript && variantMediasScript.textContent) {
        try {
          const scriptContent = variantMediasScript.textContent.trim();
          if (scriptContent) {
            variantMediasMap = JSON.parse(scriptContent);
          }
        } catch (e) {
          // Fallback to empty map
          variantMediasMap = {};
        }
      }
      
      // Get images for current variant from metafield
      // Try both string and number keys (variant IDs might be stored as strings in JSON)
      const variantId = this.currentVariant.id;
      const variantIdString = String(variantId);
      const variantIdNumber = Number(variantId);
      
      let variantMedias = variantMediasMap[variantId] || 
                          variantMediasMap[variantIdString] || 
                          variantMediasMap[variantIdNumber] || 
                          [];
      
      // Ensure variantMedias is an array
      if (!Array.isArray(variantMedias)) {
        // Fallback to old method
        return this.updateMediaFallback();
      }
      
      // Fallback to old method if metafield is empty
      if (!variantMedias || variantMedias.length === 0) {
        return this.updateMediaFallback();
      }
      
      // Use metafield images
      const mainSlider = document.querySelector(".swiper-main");
      const mainSliderWrapper = document.querySelector(
        ".swiper-main .swiper-wrapper"
      );
      if (!mainSlider || !mainSliderWrapper) return;
      
      mainSliderWrapper.style.minHeight = mainSliderWrapper.clientHeight + "px";
      mainSliderWrapper.innerHTML = "";
      
      const thumbnailsSwiper = document.querySelector(".swiper-thumbnails");
      const thumbnailsSwiperWrapper = document.querySelector(
        ".swiper-thumbnails .swiper-wrapper"
      );
      if (thumbnailsSwiper && thumbnailsSwiperWrapper) {
        thumbnailsSwiper.style.minHeight = thumbnailsSwiper.clientHeight + "px";
        thumbnailsSwiperWrapper.innerHTML = "";
      }
      
      // Process each image from metafield
      variantMedias.forEach((mediaItem, loopIndex) => {
        // Handle different metafield formats:
        // - String: direct URL
        // - Object with src/url property
        // - Shopify file_reference object
        let imageUrl = '';
        let imageAlt = '';
        
        if (typeof mediaItem === 'string') {
          imageUrl = mediaItem;
        } else if (mediaItem && typeof mediaItem === 'object') {
          // Handle Shopify file_reference format
          if (mediaItem.preview) {
            imageUrl = mediaItem.preview.image?.url || mediaItem.preview?.src || mediaItem.url || mediaItem.src;
          } else if (mediaItem.src) {
            imageUrl = mediaItem.src;
          } else if (mediaItem.url) {
            imageUrl = mediaItem.url;
          } else if (mediaItem.image) {
            imageUrl = mediaItem.image.url || mediaItem.image.src || mediaItem.image;
          }
          
          imageAlt = mediaItem.alt || mediaItem.alt_text || '';
        }
        
        // Skip if no valid URL found
          if (!imageUrl) {
            return;
          }
        
        // Ensure URL is absolute (add https: if needed)
        if (imageUrl.startsWith('//')) {
          imageUrl = 'https:' + imageUrl;
        }
        
        // Create thumbnail
        if (thumbnailsSwiperWrapper) {
          const thumbnailSlide = document.createElement("div");
          thumbnailSlide.classList.add("swiper-slide");
          const thumbnailImage = document.createElement("img");
          thumbnailImage.classList.add('preview-image-class');
          thumbnailImage.src = imageUrl;
          thumbnailImage.alt = imageAlt;
          thumbnailImage.loading = loopIndex === 0 ? 'eager' : 'lazy';
          thumbnailImage.onerror = function() {
            this.style.display = 'none';
          };
          thumbnailSlide.appendChild(thumbnailImage);
          
          if (loopIndex === 0) {
            thumbnailSlide.classList.add("active");
          }
          
          thumbnailSlide.addEventListener("click", (ev) => {
            if (mainSlider.swiper) {
              mainSlider.swiper.slideTo(loopIndex);
            }
            ev.target
              .closest(".swiper-wrapper")
              .querySelectorAll(".swiper-slide")
              .forEach((el) => el.classList.remove("active"));
            ev.target.closest(".swiper-slide").classList.add("active");
          });
          
          thumbnailsSwiperWrapper.appendChild(thumbnailSlide);
        }
        
        // Create main slide
        const mainSlide = document.createElement("div");
        mainSlide.classList.add("swiper-slide");
        mainSlide.classList.add("faded-out");
        
        // Create image element with proper attributes
        const img = document.createElement("img");
        img.src = imageUrl;
        img.alt = imageAlt;
        img.loading = loopIndex === 0 ? 'eager' : 'lazy';
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'contain';
        img.onerror = function() {
          this.style.display = 'none';
        };
        
        mainSlide.appendChild(img);
        mainSliderWrapper.appendChild(mainSlide);
        
        if (mainSlider.swiper && loopIndex === 0) {
          mainSlider.swiper.slideTo(0);
        }
        
        requestAnimationFrame(() => {
          mainSlide.classList.remove("faded-out");
        });
      });
      
      // Also update the standard product gallery if it exists
      this.updateProductGallery(variantMedias);
      
      // Force carousel to refresh if it has a refresh method
      const mediaCarousel = document.querySelector('product-gallery media-carousel');
      if (mediaCarousel && typeof mediaCarousel.refresh === 'function') {
        mediaCarousel.refresh();
      }
    }
    
    updateMediaFallback() {
      // Use existing variantImages logic as fallback
      const mainSlider = document.querySelector(".swiper-main");
      const mainSliderWrapper = document.querySelector(
        ".swiper-main .swiper-wrapper"
      );
      if (!mainSlider || !mainSliderWrapper) return;
      
      mainSliderWrapper.style.minHeight = mainSliderWrapper.clientHeight + "px";
      mainSliderWrapper.innerHTML = "";
      const thumbnailsSwiper = document.querySelector(".swiper-thumbnails");
      const thumbnailsSwiperWrapper = document.querySelector(
        ".swiper-thumbnails .swiper-wrapper"
      );
      if (thumbnailsSwiper && thumbnailsSwiperWrapper) {
        thumbnailsSwiper.style.minHeight = thumbnailsSwiper.clientHeight + "px";
        thumbnailsSwiperWrapper.innerHTML = "";
      }
      
      if (typeof variantImages !== 'undefined' && variantImages && variantImages[this.currentVariant.id]) {
        variantImages[this.currentVariant.id].forEach((variantIndex, loopIndex) => {
          const thumbnailSlide = document.createElement("div");
          thumbnailSlide.classList.add("swiper-slide");
          const thumbnailImage = document.createElement("img");
          thumbnailImage.classList.add('preview-image-class');
          if (typeof productImageURLS !== 'undefined' && productImageURLS[variantIndex]) {
            thumbnailImage.src = productImageURLS[variantIndex];
          }
          if (thumbnailsSwiperWrapper) {
            thumbnailSlide.appendChild(thumbnailImage);
            if (loopIndex === 0) {
              thumbnailSlide.classList.add("active");
            }
            thumbnailSlide.addEventListener("click", (ev) => {
              if (mainSlider.swiper) {
                mainSlider.swiper.slideTo(loopIndex);
              }
              ev.target
                .closest(".swiper-wrapper")
                .querySelectorAll(".swiper-slide")
                .forEach((el) => el.classList.remove("active"));
              ev.target.closest(".swiper-slide").classList.add("active");
            });
            thumbnailsSwiperWrapper.appendChild(thumbnailSlide);
          }
          const mainSlide = document.createElement("div");
          mainSlide.classList.add("swiper-slide");
          mainSlide.classList.add("faded-out");
          if (typeof productImages2 !== 'undefined' && productImages2[variantIndex]) {
            mainSlide.innerHTML = productImages2[variantIndex];
          }
          mainSliderWrapper.appendChild(mainSlide);
          if (mainSlider.swiper){
            mainSlider.swiper.slideTo(0);
          }
          requestAnimationFrame(() => {
            mainSlide.classList.remove("faded-out");
          });
        });
      }
    }
    
    updateProductGallery(variantMedias) {
      var pickupEl = document.querySelector('pickup-availability');
      if (pickupEl) {
        pickupEl.classList.add('pickup-availability--updating');
        if (this._pickupHideTimeout) clearTimeout(this._pickupHideTimeout);
        this._pickupHideTimeout = setTimeout(function() {
          pickupEl.classList.remove('pickup-availability--updating');
        }, 1400);
      }
      const productGallery = document.querySelector('product-gallery');
      if (!productGallery) {
        return;
      }
      // Theme uses <ul class="custom-media-carousel"> (no media-carousel element)
      const mediaListEl = productGallery.querySelector('.custom-media-carousel') || productGallery.querySelector('.product-gallery__media-list');
      if (!mediaListEl) {
        return;
      }
      const controller = mediaListEl.__controller;
      
      if (!variantMedias || variantMedias.length === 0) {
        const existingMedia = productGallery.querySelectorAll('.product-gallery__media');
        existingMedia.forEach(media => media.removeAttribute('hidden'));
        const thumbnails = productGallery.querySelectorAll('.product-gallery__thumbnail');
        thumbnails.forEach(thumb => thumb.removeAttribute('hidden'));
        productGallery.querySelectorAll('.product-gallery__thumbnail-list li').forEach(li => li.removeAttribute('hidden'));
        productGallery.removeAttribute('filtered-indexes');
        if (controller && controller._items != null) controller._items = null;
        if (controller && controller.select) controller.select(0, { animate: false });
        return;
      }
      
      const extractImageUrl = (mediaItem) => {
        if (typeof mediaItem === 'string') return mediaItem;
        if (mediaItem && typeof mediaItem === 'object') {
          if (mediaItem.preview) {
            return mediaItem.preview.image?.url || mediaItem.preview?.src || mediaItem.url || mediaItem.src || '';
          }
          return mediaItem.src || mediaItem.url || mediaItem.image?.url || mediaItem.image?.src || '';
        }
        return '';
      };
      const variantImageUrls = variantMedias
        .map(extractImageUrl)
        .filter(url => url)
        .map(url => url.startsWith('//') ? 'https:' + url : url.startsWith('/') ? window.location.origin + url : url);
      
      if (variantImageUrls.length === 0) {
        return;
      }
      
      for (let i = 0; i < Math.min(3, variantImageUrls.length); i++) {
        var preload = new Image();
        preload.src = variantImageUrls[i];
      }
      
      var self = this;
      requestAnimationFrame(function runGalleryUpdate() {
      const existingMedia = Array.from(mediaListEl.querySelectorAll('.product-gallery__media'));
      const existingThumbnailListItems = Array.from(productGallery.querySelectorAll('.product-gallery__thumbnail-list li'));
      const existingThumbnailButtons = Array.from(productGallery.querySelectorAll('.product-gallery__thumbnail'));
      
      // Hide all first, then show and update only existing slots (do not create new list items)
      existingMedia.forEach(media => media.setAttribute('hidden', ''));
      existingThumbnailListItems.forEach(li => li.setAttribute('hidden', ''));
      existingThumbnailButtons.forEach(thumb => { thumb.onclick = null; });
      
      variantImageUrls.forEach((variantUrl, index) => {
        const urlWithoutParams = variantUrl.split('?')[0];
        const mediaElement = existingMedia[index];
        if (mediaElement) {
          const img = mediaElement.querySelector('img');
          if (img) {
            img.loading = index === 0 ? 'eager' : 'lazy';
            img.src = variantUrl;
            img.srcset = `${urlWithoutParams}?width=200 200w, ${urlWithoutParams}?width=400 400w, ${urlWithoutParams}?width=600 600w, ${urlWithoutParams}?width=800 800w, ${urlWithoutParams}?width=1000 1000w, ${urlWithoutParams}?width=1200 1200w, ${urlWithoutParams}?width=1600 1600w`;
            img.sizes = '(max-width: 740px) calc(100vw - 40px), (max-width: 999px) calc(100vw - 64px), min(760px, 42vw)';
            if (variantMedias[index]?.alt) img.alt = variantMedias[index].alt;
            mediaElement.setAttribute('data-media-type', 'image');
            mediaElement.removeAttribute('hidden');
          }
        }
        
        const thumbnailListItem = existingThumbnailListItems[index];
        const thumbnail = existingThumbnailButtons[index];
        if (thumbnailListItem && thumbnail) {
          const thumbImg = thumbnail.querySelector('img');
          if (thumbImg) {
            thumbImg.loading = index === 0 ? 'eager' : 'lazy';
            thumbImg.src = variantUrl;
            thumbImg.srcset = `${urlWithoutParams}?width=56 56w, ${urlWithoutParams}?width=64 64w, ${urlWithoutParams}?width=112 112w, ${urlWithoutParams}?width=128 128w`;
            thumbImg.sizes = '(max-width: 699px) 56px, 64px';
            if (variantMedias[index]?.alt) thumbImg.alt = variantMedias[index].alt;
          }
          thumbnailListItem.removeAttribute('hidden');
          thumbnail.removeAttribute('hidden');
          thumbnail.setAttribute('aria-current', index === 0 ? 'true' : 'false');
          thumbnailListItem.setAttribute('aria-current', index === 0 ? 'true' : 'false');
          const currentIndex = index;
          thumbnail.onclick = () => {
            productGallery.querySelectorAll('.product-gallery__thumbnail-list li').forEach(li => li.setAttribute('aria-current', 'false'));
            productGallery.querySelectorAll('.product-gallery__thumbnail').forEach(t => t.setAttribute('aria-current', 'false'));
            thumbnailListItem.setAttribute('aria-current', 'true');
            thumbnail.setAttribute('aria-current', 'true');
            if (controller && controller.select) controller.select(currentIndex, { animate: true });
          };
        }
      });
      
      for (let i = variantImageUrls.length; i < existingMedia.length; i++) {
        existingMedia[i]?.setAttribute('hidden', '');
        if (existingThumbnailListItems[i]) existingThumbnailListItems[i].setAttribute('hidden', '');
      }
      
      if (controller && controller._items != null) controller._items = null;
      
      const allMedia = Array.from(mediaListEl.querySelectorAll('.product-gallery__media'));
      const hiddenPositions = [];
      allMedia.forEach((media, idx) => {
        if (media.hasAttribute('hidden')) hiddenPositions.push(idx + 1);
      });
      if (hiddenPositions.length > 0) {
        productGallery.setAttribute('filtered-indexes', JSON.stringify(hiddenPositions));
      } else {
        productGallery.removeAttribute('filtered-indexes');
      }
      
      setTimeout(function() {
        if (controller && controller.select) controller.select(0, { animate: false });
        var cursor = productGallery.querySelector('.product-gallery__cursor');
        var firstVisible = mediaListEl.querySelector('.product-gallery__media:not([hidden])');
        if (cursor && firstVisible && firstVisible.getAttribute('data-media-type') === 'image') {
          cursor.removeAttribute('hidden');
        }
      }, 0);
      });
    }
}

customElements.define("variant-colour-swatch", VariantColourSwatch);

// Set up variant change listener at module level - this will always run
// Listen to variant change events from theme's VariantPicker on document level
// The event bubbles up from the form to the document
(function() {
  'use strict';
  
  let _variantMediasCache = { content: '', parsed: null };
  function getVariantMediasMap() {
    const script = document.querySelector('[data-variant-medias]');
    if (!script || !script.textContent) return {};
    const content = script.textContent.trim();
    if (!content) return {};
    if (content === _variantMediasCache.content && _variantMediasCache.parsed) return _variantMediasCache.parsed;
    try {
      const parsed = JSON.parse(content);
      _variantMediasCache = { content, parsed: parsed || {} };
      return _variantMediasCache.parsed;
    } catch (e) {
      return {};
    }
  }

  // Function to update gallery from metafield
  function updateGalleryFromMetafield(variant) {
    if (!variant || !variant.id) {
      return;
    }
    const variantMediasMap = getVariantMediasMap();
    
    // Try both string and number keys (variant IDs might be stored as strings in JSON)
    const variantId = variant.id;
    const variantIdString = String(variantId);
    const variantIdNumber = Number(variantId);
    
    let variantMedias = variantMediasMap[variantId] || 
                        variantMediasMap[variantIdString] || 
                        variantMediasMap[variantIdNumber] || 
                        [];
    
    // Use variant metafield images; put variant's featured image first if it exists
    if (Array.isArray(variantMedias) && variantMedias.length > 0) {
      updateProductGalleryFromMetafield(variantMedias, variantId, variant);
    } else {
      const featuredOnly = getVariantFeaturedMediaAsFormat(variant);
      if (featuredOnly && featuredOnly.length > 0) {
        updateProductGalleryFromMetafield(featuredOnly, variantId, variant);
      }
    }
  }

  // When variant has no metafield images, show only its featured image (avoids showing other colors)
  function getVariantFeaturedMediaAsFormat(variant) {
    if (!variant || !variant.featured_media) return null;
    const m = variant.featured_media;
    if (m.media_type !== 'image' && !m.preview_image) return null;
    const src = m.preview_image?.src || m.src || '';
    if (!src) return null;
    return [{ src, alt: m.alt || m.preview_image?.alt || '' }];
  }

  // Normalize Shopify product.media (from data-product-media) to same shape as variant metafield media
  function getProductMediaAsVariantFormat() {
    const script = document.querySelector('[data-product-media]');
    if (!script || !script.textContent) return null;
    try {
      const media = JSON.parse(script.textContent.trim());
      if (!Array.isArray(media)) return null;
      return media
        .filter((m) => m && (m.media_type === 'image' || m.preview_image))
        .map((m) => ({
          src: m.preview_image?.src || m.src || (typeof m === 'string' ? m : ''),
          alt: m.alt || m.preview_image?.alt || ''
        }))
        .filter((m) => m.src);
    } catch (_) {
      return null;
    }
  }
  
  // Ensure gallery/thumbnail images display consistently when variant images vary in size
  function ensureGalleryImageStyles() {
    const id = 'latori-gallery-image-styles';
    if (document.getElementById(id)) return;
    const style = document.createElement('style');
    style.id = id;
    style.textContent = `
      product-gallery [hidden] {
        display: none !important;
      }
      product-gallery .product-gallery__media img {
        object-fit: contain;
        width: 100%;
        height: auto;
        max-height: 100%;
        display: block;
      }
      product-gallery .product-gallery__thumbnail img {
        object-fit: contain;
        width: 100%;
        height: 100%;
        display: block;
      }
    `;
    document.head.appendChild(style);
  }

  // Standalone function to update product gallery (variant change from form). Uses existing list structure only (ul > li).
  function updateProductGalleryFromMetafield(variantMedias, variantId, variant) {
    ensureGalleryImageStyles();
    const productGallery = document.querySelector('product-gallery');
    if (!productGallery) {
      return;
    }
    const mediaListEl = productGallery.querySelector('.custom-media-carousel') || productGallery.querySelector('.product-gallery__media-list');
    if (!mediaListEl) {
      return;
    }
    const controller = mediaListEl.__controller;
    
    if (!variantMedias || variantMedias.length === 0) {
      requestAnimationFrame(function() {
        productGallery.querySelectorAll('.product-gallery__media').forEach(media => media.removeAttribute('hidden'));
        productGallery.querySelectorAll('.product-gallery__thumbnail').forEach(thumb => thumb.removeAttribute('hidden'));
        productGallery.querySelectorAll('.product-gallery__thumbnail-list li').forEach(li => li.removeAttribute('hidden'));
        productGallery.removeAttribute('filtered-indexes');
        if (controller && controller._items != null) controller._items = null;
        if (controller && controller.select) controller.select(0, { animate: false });
      });
      return;
    }
    
    const extractImageUrl = (mediaItem) => {
      if (typeof mediaItem === 'string') return mediaItem;
      if (!mediaItem || typeof mediaItem !== 'object') return '';
      if (mediaItem.preview) {
        return mediaItem.preview.image?.url || mediaItem.preview?.src || mediaItem.url || mediaItem.src || '';
      }
      return mediaItem.src || mediaItem.url || mediaItem.image?.url || mediaItem.image?.src || '';
    };
    const normalizeUrl = (url) => {
      if (!url) return '';
      const u = url.startsWith('//') ? 'https:' + url : url.startsWith('/') ? window.location.origin + url : url;
      return u.split('?')[0];
    };
    
    let medias = variantMedias;
    // if (variant?.featured_media) {
    //   const m = variant.featured_media;
    //   const src = m.preview_image?.src || m.src || '';
    //   if (src) {
    //     const normalizedFeaturedSrc = src.startsWith('//') ? 'https:' + src : src.startsWith('/') ? window.location.origin + src : src;
    //     const featuredItem = { src: normalizedFeaturedSrc, alt: m.alt || m.preview_image?.alt || '' };
    //     medias = [featuredItem, ...variantMedias];
    //     const seen = new Set([normalizeUrl(normalizedFeaturedSrc)]);
    //     medias = medias.filter((item) => {
    //       const url = normalizeUrl(extractImageUrl(item));
    //       if (!url || seen.has(url)) return false;
    //       seen.add(url);
    //       return true;
    //     });
    //   }
    // }
    
    const variantImageUrls = medias
      .map(extractImageUrl)
      .filter(url => url)
      .map(url => (url.startsWith('//') ? 'https:' + url : url.startsWith('/') ? window.location.origin + url : url));
    
    if (variantImageUrls.length === 0) {
      return;
    }
    for (var pi = 0; pi < Math.min(3, variantImageUrls.length); pi++) {
      var preloadImg = new Image();
      preloadImg.src = variantImageUrls[pi];
    }

    requestAnimationFrame(function runGalleryUpdate() {
    let existingMedia = Array.from(mediaListEl.querySelectorAll('.product-gallery__media'));
    const existingThumbnailListItems = Array.from(productGallery.querySelectorAll('.product-gallery__thumbnail-list li'));
    const existingThumbnailButtons = Array.from(productGallery.querySelectorAll('.product-gallery__thumbnail'));

    existingMedia.forEach(media => media.setAttribute('hidden', ''));
    existingThumbnailListItems.forEach(li => li.setAttribute('hidden', ''));
    existingThumbnailButtons.forEach(thumb => { thumb.onclick = null; });


    // If there are not enough media elements, create them
    if (variantImageUrls.length > existingMedia.length) {
      for (let i = existingMedia.length; i < variantImageUrls.length; i++) {
        const li = document.createElement('li');
        li.className = 'product-gallery__media snap-center';
        li.setAttribute('data-media-type', 'image');
        li.setAttribute('data-media-id', `variant-media-${i}`);
        const img = document.createElement('img');
        img.src = variantImageUrls[i];
        img.alt = medias[i]?.alt || '';
        img.loading = i === 0 ? 'eager' : 'lazy';
        img.srcset = `${variantImageUrls[i].split('?')[0]}?width=200 200w, ${variantImageUrls[i].split('?')[0]}?width=400 400w, ${variantImageUrls[i].split('?')[0]}?width=600 600w, ${variantImageUrls[i].split('?')[0]}?width=800 800w, ${variantImageUrls[i].split('?')[0]}?width=1000 1000w, ${variantImageUrls[i].split('?')[0]}?width=1200 1200w, ${variantImageUrls[i].split('?')[0]}?width=1600 1600w`;
        img.sizes = '(max-width: 740px) calc(100vw - 40px), (max-width: 999px) calc(100vw - 64px), min(760px, 42vw)';
        li.appendChild(img);
        mediaListEl.appendChild(li);
        existingMedia.push(li);
      }
    }

    // If there are not enough thumbnail elements, create them
    const thumbnailList = productGallery.querySelector('.product-gallery__thumbnail-list');
    if (variantImageUrls.length > existingThumbnailListItems.length && thumbnailList) {
      for (let i = existingThumbnailListItems.length; i < variantImageUrls.length; i++) {
        const li = document.createElement('li');
        li.setAttribute('aria-label', `Go to item ${i + 1}`);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-gallery__thumbnail';
        button.setAttribute('aria-label', `Go to item ${i + 1}`);
        const thumbImg = document.createElement('img');
        thumbImg.src = variantImageUrls[i];
        thumbImg.alt = medias[i]?.alt || '';
        thumbImg.loading = i === 0 ? 'eager' : 'lazy';
        thumbImg.srcset = `${variantImageUrls[i].split('?')[0]}?width=56 56w, ${variantImageUrls[i].split('?')[0]}?width=64 64w, ${variantImageUrls[i].split('?')[0]}?width=112 112w, ${variantImageUrls[i].split('?')[0]}?width=128 128w`;
        thumbImg.sizes = '(max-width: 699px) 56px, 64px';
        button.appendChild(thumbImg);
        li.appendChild(button);
        thumbnailList.appendChild(li);
        existingThumbnailListItems.push(li);
        existingThumbnailButtons.push(button);
      }
    }


    // Re-attach click handlers for all thumbnails (including new ones)
    existingThumbnailButtons.forEach((thumbnail, index) => {
      thumbnail.onclick = () => {
        // Remove aria-current from all
        existingThumbnailListItems.forEach(li => li.setAttribute('aria-current', 'false'));
        existingThumbnailButtons.forEach(t => t.setAttribute('aria-current', 'false'));
        existingMedia.forEach(media => media.setAttribute('aria-current', 'false'));
        // Set aria-current for selected
        existingThumbnailListItems[index].setAttribute('aria-current', 'true');
        thumbnail.setAttribute('aria-current', 'true');
        existingMedia[index].setAttribute('aria-current', 'true');
        // Show selected media
        existingMedia.forEach((media, idx) => {
          if (idx === index) {
            media.removeAttribute('hidden');
          } else {
            media.setAttribute('hidden', '');
          }
        });
        // Select in controller
        if (controller && controller.select) controller.select(index, { animate: true });
      };
    });


    // Patch scroll controls to handle new images
    const scrollLeftBtn = productGallery.querySelector('.product-gallery__scroll-left');
    const scrollRightBtn = productGallery.querySelector('.product-gallery__scroll-right');
    if (scrollLeftBtn && scrollRightBtn && controller && typeof controller.select === 'function') {
      scrollLeftBtn.onclick = () => {
        let currentIndex = existingMedia.findIndex(media => media.getAttribute('aria-current') === 'true');
        if (currentIndex === -1) currentIndex = 0;
        const prevIndex = Math.max(currentIndex - 1, 0);
        // Update aria-current and visibility
        existingThumbnailListItems.forEach(li => li.setAttribute('aria-current', 'false'));
        existingThumbnailButtons.forEach(t => t.setAttribute('aria-current', 'false'));
        existingMedia.forEach(media => media.setAttribute('aria-current', 'false'));
        existingThumbnailListItems[prevIndex].setAttribute('aria-current', 'true');
        existingThumbnailButtons[prevIndex].setAttribute('aria-current', 'true');
        existingMedia[prevIndex].setAttribute('aria-current', 'true');
        existingMedia.forEach((media, idx) => {
          if (idx === prevIndex) {
            media.removeAttribute('hidden');
          } else {
            media.setAttribute('hidden', '');
          }
        });
        controller.select(prevIndex, { animate: true });
      };
      scrollRightBtn.onclick = () => {
        let currentIndex = existingMedia.findIndex(media => media.getAttribute('aria-current') === 'true');
        if (currentIndex === -1) currentIndex = 0;
        const nextIndex = Math.min(currentIndex + 1, existingMedia.length - 1);
        // Update aria-current and visibility
        existingThumbnailListItems.forEach(li => li.setAttribute('aria-current', 'false'));
        existingThumbnailButtons.forEach(t => t.setAttribute('aria-current', 'false'));
        existingMedia.forEach(media => media.setAttribute('aria-current', 'false'));
        existingThumbnailListItems[nextIndex].setAttribute('aria-current', 'true');
        existingThumbnailButtons[nextIndex].setAttribute('aria-current', 'true');
        existingMedia[nextIndex].setAttribute('aria-current', 'true');
        existingMedia.forEach((media, idx) => {
          if (idx === nextIndex) {
            media.removeAttribute('hidden');
          } else {
            media.setAttribute('hidden', '');
          }
        });
        controller.select(nextIndex, { animate: true });
      };
    }

    // Now update all media and thumbnails
    variantImageUrls.forEach((variantUrl, index) => {
      const urlWithoutParams = variantUrl.split('?')[0];
      const mediaElement = existingMedia[index];
      if (mediaElement) {
        const img = mediaElement.querySelector('img');
        if (img) {
          img.loading = index === 0 ? 'eager' : 'lazy';
          img.src = variantUrl;
          img.srcset = `${urlWithoutParams}?width=200 200w, ${urlWithoutParams}?width=400 400w, ${urlWithoutParams}?width=600 600w, ${urlWithoutParams}?width=800 800w, ${urlWithoutParams}?width=1000 1000w, ${urlWithoutParams}?width=1200 1200w, ${urlWithoutParams}?width=1600 1600w`;
          img.sizes = '(max-width: 740px) calc(100vw - 40px), (max-width: 999px) calc(100vw - 64px), min(760px, 42vw)';
          if (medias[index]?.alt) img.alt = medias[index].alt;
          mediaElement.setAttribute('data-media-type', 'image');
          mediaElement.removeAttribute('hidden');
        }
      }
      const thumbnailListItem = existingThumbnailListItems[index];
      const thumbnail = existingThumbnailButtons[index];
      if (thumbnailListItem && thumbnail) {
        const thumbImg = thumbnail.querySelector('img');
        if (thumbImg) {
          thumbImg.loading = index === 0 ? 'eager' : 'lazy';
          thumbImg.src = variantUrl;
          thumbImg.srcset = `${urlWithoutParams}?width=56 56w, ${urlWithoutParams}?width=64 64w, ${urlWithoutParams}?width=112 112w, ${urlWithoutParams}?width=128 128w`;
          thumbImg.sizes = '(max-width: 699px) 56px, 64px';
          if (medias[index]?.alt) thumbImg.alt = medias[index].alt;
        }
        thumbnailListItem.removeAttribute('hidden');
        thumbnail.removeAttribute('hidden');
        thumbnail.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        thumbnailListItem.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        const currentIndex = index;
        thumbnail.onclick = () => {
          productGallery.querySelectorAll('.product-gallery__thumbnail-list li').forEach(li => li.setAttribute('aria-current', 'false'));
          productGallery.querySelectorAll('.product-gallery__thumbnail').forEach(t => t.setAttribute('aria-current', 'false'));
          thumbnailListItem.setAttribute('aria-current', 'true');
          thumbnail.setAttribute('aria-current', 'true');
          if (controller && controller.select) controller.select(currentIndex, { animate: true });
        };
      }
    });

    for (let i = variantImageUrls.length; i < existingMedia.length; i++) {
      existingMedia[i]?.setAttribute('hidden', '');
    }
    for (let i = variantImageUrls.length; i < existingThumbnailListItems.length; i++) {
      existingThumbnailListItems[i]?.setAttribute('hidden', '');
    }

    if (controller && controller._items != null) controller._items = null;

    const allMedia = Array.from(mediaListEl.querySelectorAll('.product-gallery__media'));
    const hiddenPositions = [];
    allMedia.forEach((media, idx) => {
      if (media.hasAttribute('hidden')) hiddenPositions.push(idx + 1);
    });
    if (hiddenPositions.length > 0) {
      productGallery.setAttribute('filtered-indexes', JSON.stringify(hiddenPositions));
    } else {
      productGallery.removeAttribute('filtered-indexes');
    }

    const filteredIndexes = hiddenPositions.map((p) => p - 1);
    productGallery.querySelectorAll('.custom-media-carousel').forEach((el) => {
      el.dispatchEvent(new CustomEvent('carousel:filter', { detail: { filteredIndexes } }));
    });
    productGallery.querySelectorAll('page-dots, .custom-page-dots').forEach((el) => {
      el.dispatchEvent(new CustomEvent('control:filter', { detail: { filteredIndexes } }));
    });
    window.dispatchEvent(new Event('resize'));
    setTimeout(function() {
      if (controller && controller.select) controller.select(0, { animate: false });
      const cursor = productGallery.querySelector('.product-gallery__cursor');
      const firstVisible = mediaListEl.querySelector('.product-gallery__media:not([hidden])');
      if (cursor && firstVisible && firstVisible.getAttribute('data-media-type') === 'image') {
        cursor.removeAttribute('hidden');
      }
    }, 0);
    });
  }
  
  function setupVariantChangeListener() {
    document.addEventListener(
      'variant:change',
      (event) => {
        if (event.detail && event.detail.variant) {
          updateGalleryFromMetafield(event.detail.variant);
        }
      },
      true
    );
  }

  function defer(fn) {
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(fn, { timeout: 200 });
    } else {
      setTimeout(fn, 0);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => defer(setupVariantChangeListener));
  } else {
    defer(setupVariantChangeListener);
  }
})();

// Patch theme.js ProductRerender to fix null reference error for buy-buttons
// This fixes the error at theme.js:3113 where it tries to access buy-buttons without null check
(function() {
  'use strict';
  
  // Function to ensure buy-buttons elements exist in blocks
  function ensureBuyButtonsInBlocks(container) {
    if (!container || !container.querySelectorAll) return;
    
    const buyButtonsBlocks = container.querySelectorAll('[data-block-type="buy-buttons"]');
    buyButtonsBlocks.forEach(block => {
      if (!block.querySelector('buy-buttons')) {
        // Create a placeholder buy-buttons element to prevent null reference
        const placeholder = document.createElement('buy-buttons');
        placeholder.style.display = 'none';
        
        // Safely get form ID - handle both Element and DocumentFragment
        let formId = '';
        if (block.closest && typeof block.closest === 'function') {
          formId = block.closest('form')?.id || '';
        }
        if (!formId && container && typeof container.getAttribute === 'function') {
          formId = container.getAttribute('observe-form') || '';
        }
        if (!formId && container && container.nodeType === 11) {
          // DocumentFragment - try to find form in the fragment
          const form = container.querySelector?.('form');
          formId = form?.id || '';
        }
        
        if (formId) {
          placeholder.setAttribute('form', formId);
        }
        block.appendChild(placeholder);
      }
    });
  }
  
  // Intercept product:rerender events in capture phase (runs BEFORE theme's handler)
  document.addEventListener('product:rerender', function(event) {
    // Get the HTML fragment from the event detail (the new content being rendered)
    const htmlFragment = event.detail?.htmlFragment;
    
    // Ensure buy-buttons exist in the current DOM
    const productRerenders = document.querySelectorAll('product-rerender');
    productRerenders.forEach(productRerender => {
      ensureBuyButtonsInBlocks(productRerender);
    });
    
    // Also ensure buy-buttons exist in the new HTML fragment
    // The fragment could be a DocumentFragment or Element
    if (htmlFragment) {
      try {
        // Try to query it directly
        if (htmlFragment.querySelector) {
          ensureBuyButtonsInBlocks(htmlFragment);
        }
        // If it's a DocumentFragment, we need to handle it differently
        if (htmlFragment.nodeType === 11) { // DocumentFragment
          const buyButtonsBlocks = htmlFragment.querySelectorAll('[data-block-type="buy-buttons"]');
          buyButtonsBlocks.forEach(block => {
            if (!block.querySelector('buy-buttons')) {
              const placeholder = document.createElement('buy-buttons');
              placeholder.style.display = 'none';
              const formId = event.target?.id || '';
              if (formId) {
                placeholder.setAttribute('form', formId);
              }
              block.appendChild(placeholder);
            }
          });
        }
      } catch (e) {
        // Error handling
      }
    }
  }, true); // Capture phase - runs BEFORE theme's handler (must be synchronous)
  
  // Also ensure buy-buttons exist on page load
  function initializeBuyButtonsCheck() {
    const productRerenders = document.querySelectorAll('product-rerender');
    productRerenders.forEach(productRerender => {
      ensureBuyButtonsInBlocks(productRerender);
    });
  }
  
  function defer(fn) {
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(fn, { timeout: 300 });
    } else {
      setTimeout(fn, 0);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => defer(initializeBuyButtonsCheck));
  } else {
    defer(initializeBuyButtonsCheck);
  }
  setTimeout(initializeBuyButtonsCheck, 400);
  
  // Use MutationObserver to watch for new product-rerender elements
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          if (node.tagName === 'PRODUCT-RERENDER') {
            ensureBuyButtonsInBlocks(node);
          } else {
            const productRerenders = node.querySelectorAll?.('product-rerender');
            if (productRerenders) {
              productRerenders.forEach(pr => ensureBuyButtonsInBlocks(pr));
            }
          }
        }
      });
    });
  });
  
  // Start observing
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
})();
